import {createContext} from "react";
import {DrupalEmptyNavMenuLinkContent} from "../types/hygiena-types";

/**
 * The modal contexts are used to trigger and populate modals and their content.
 */
export const EmptyNavMenuContext = createContext([] as DrupalEmptyNavMenuLinkContent[]);
